var React = require('react');

function GreyPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.837 12.595C.054 9.714.054 5.042 2.837 2.161a6.953 6.953 0 0110.076 0c2.783 2.881 2.783 7.553 0 10.434l-5.038 5.217-5.038-5.217zm5.038-2.217c1.6 0 2.897-1.343 2.897-3s-1.297-3-2.897-3c-1.6 0-2.897 1.343-2.897 3s1.297 3 2.897 3z","fill":"#C4C4C4"}));
}

GreyPin.defaultProps = {"width":"15","height":"18","fill":"none"};

module.exports = GreyPin;

GreyPin.default = GreyPin;
